import React from "react";
import { MemberDropdown, MyAccountButton } from "@pga/pga-component-library";

export default ({
  isLoggedIn,
  loading,
  me,
  options,
  meEmailMigrationData,
  onToggleDoNotShowAgain,
}) =>
  isLoggedIn ? (
    <MemberDropdown
      loading={loading}
      me={me}
      options={options}
      meEmailMigrationData={meEmailMigrationData}
      onToggleDoNotShowAgain={onToggleDoNotShowAgain}
    />
  ) : (
    <MyAccountButton />
  );
